<template>
  <div class="risk-bar">
    <div 
      class="risk-indicator"
      :style="indicatorStyle">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    riskPercent: {
      type: Number,
      validator: function(value) {
        return value >= 0 && value <= 100;
      }
    },
  },

  data: function() {
    return {
      indicatorWidth: 0.2,
    };
  },

  computed: {
    indicatorStyle() {
      return {
        left: (this.riskPercent * (1 - this.indicatorWidth)) + '%',
        width: (this.indicatorWidth * 100) + '%',
      };
    }
  },
}
</script>

<style scoped>
.risk-bar {
  background: #242424;
  border: solid 1px #484848;
  height: 16px;
  position: relative;
  border-radius: 4px;
}

.risk-indicator {
  background: linear-gradient(to right, transparent 0, #79f8f2 25%, #79f8f2 75%, transparent 100%) no-repeat;
  height: 100%;
  position: absolute;
  border-radius: 4px;
}
</style>
